import React from "react";
import banner from "../../asset/authority banner.jpeg";
import image from "../../asset/authority image.png";



const AboutAuthority = () => {
  const governingBodyList = [
    "Chairman.",
    "03 members of Provincial Assembly",
    "Chairman Planning & Development Board or his representative.",
    "Secretary of the Govt. of Punjab, Finance Department or his representative.",
    "Secretary of the Govt. of Punjab, LG & CD Department or his representative.",
    "Secretary of the Govt. of Punjab,  HUD & PHE Department or his representative.",
    "Mayor of the Rawalpindi",
    "Commissioner Rawalpindi",
    "Director General RDA Rawalpindi",
    "Deputy Commissioner Rawalpindi",
    "Managing Director WASA Rawalpindi",
    "02 technical members",
  ];
  const directoratesList = [
    "Directorate of Metropolitan Planning and Traffic Engineering",
    "Directorate of Land Development and Estate Management.",
    "Directorate of Engineering.",
    "Directorate of Administration and Finance",
  ];
  const functionsList = [
    "To evolve policies & programs relating to the improvement of the environment, housing, water supply, sewerage & drainage",
    "To take measures to ensure optimum utilization of resources",
    "To ensure economical & effective utilization of land",
    "To prepare & execute new schemes",
    "To approve budget & make regulations",
    "To preserve and improve environment",
    "To plan, guide, control, and implement short and long term development projects",
    "To preserve traffic & transportation corridors, roads, bridges, industry, education, health and planning execution Etc.",
    "Building, land use control, and urban development plans",
    "To launch housing schemes and other projects, particularly of the nature of joint venture and on BOT basis",
    "Approval and control over private housing schemes",
    "To acquire property, both movable and immovable",
    "To enter into contracts for case studies, surveys, experiments, technical researches or contribute towards the cost of any such studies",
    "To issue Interim development order",
    "To establish an Agency / Agencies and entrust such powers and functions as it may deem fit with the approval of the Government",
  ];

  return (
    <div className="flex flex-col gap-10  md:pb-20 pb-10  bg-white md:bg-[#F6F6F6]  xl:px-[5%] lg:px-[3%] md:px-[3%] px-[6%]">
      {" "}
      <div className="xl:py-6 lg:py-4 py-3">
        <img src={banner} alt="" className="lg:rounded-2xl rounded-xl w-full" />
      </div>
      <div className="flex items-center gap-10">
        <div className=" md:w-[60%] w-full flex flex-col gap-4">
          <h1 className=" md:text-[2.5rem] text-[1.8rem]  font-bold ">
            Governing Body
          </h1>
          <p className="md:text-[1.3rem] text-[1rem] uppercase md:normal-case  text-[#7A7A7A]">
            The members of the Governing Body for the Rawalpindi Development
            Authority consist of..
          </p>
          <ul className="list-disc pl-8 md:text-[1.3rem] text-[1rem] uppercase md:normal-case text-[#7A7A7A] ">
            {governingBodyList.map((li, i) => (
              <li key={i}>{li}</li>
            ))}
          </ul>
        </div>
        <div className=" hidden md:flex w-[40%]">
          {" "}
          <img src={image} className="rounded-2xl" alt="" />
        </div>
      </div>
      <div className=" flex flex-col gap-4">
        <h1 className=" md:text-[2.5rem] text-[1.8rem]  font-bold ">
          Directorates
        </h1>
        <p className="md:text-[1.3rem] text-[1rem] uppercase md:normal-case text-[#7A7A7A]">
          There are 4 directorates of the Rawalpindi Development Authority:
        </p>
        <ul className="list-decimal pl-8 md:text-[1.3rem] text-[1rem] uppercase md:normal-case text-[#7A7A7A] ">
          {directoratesList.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </ul>
      </div>
      <div className=" flex flex-col gap-4">
        <h1 className=" md:text-[2.5rem] text-[1.8rem]  font-bold ">
          Powers & Functions of Authority
        </h1>
        <p className="md:text-[1.3rem] text-[1rem] uppercase md:normal-case  text-[#7A7A7A]">
          These are the main and prominent incentives and services from
          Rawalpindi Development Authority.
        </p>
        <ul className="list-disc pl-8 md:text-[1.3rem] text-[1rem] uppercase md:normal-case text-[#7A7A7A] ">
          {functionsList.map((li, i) => (
            <li key={i}>{li}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AboutAuthority;
